import { Wallet, Globe, Zap, Clock, Headphones, CalendarClock } from "lucide-react";
import SectionHeading from "../components/SectionHeading";
import Reveal from "../components/Reveal";
import GridTexture from "../components/GridTexture";

const FEATURES = [
  {
    icon: Wallet,
    title: "15 Dagen Geld-Terug-Garantie",
    text: "Niet helemaal tevreden met je IPTV-abonnement? Geen zorgen! Wij bieden 15 dagen niet-goed-geld-terug garantie voor een volledige terugbetaling.",
  },
  {
    icon: Globe,
    title: "79.000+ Zenders Wereldwijd",
    text: "Toegang tot meer dan 79.000 live TV-zenders en 249.000 films en series, inclusief alle Nederlandse, Belgische en Europese kanalen.",
  },
  {
    icon: Zap,
    title: "Ultra Snelle Verbinding",
    text: "TiviOne maakt gebruik van eigen Europese servers van topkwaliteit, waardoor zenders in 0,5 seconden laden — zonder haperingen of buffering.",
  },
  {
    icon: Clock,
    title: "Directe Installatie",
    text: "Installeer je IPTV-abonnement eenvoudig op elk apparaat. Wij bieden gratis hulp bij installatie en activering van IBO Pro Player.",
  },
  {
    icon: Headphones,
    title: "24/7 Klantenondersteuning",
    text: "Ons ondersteuningsteam is dag en nacht bereikbaar via WhatsApp en e-mail om je stap voor stap te begeleiden.",
  },
  {
    icon: CalendarClock,
    title: "Catch-up & EPG",
    text: "Volledige TV-gids en catch-up-functie, zodat je nooit meer een aflevering of wedstrijd mist.",
  },
];

export default function Why() {
  return (
    <section className="py-14 sm:py-20 bg-surface-secondary relative overflow-hidden" style={{ "--section-bg": "#000000" }}>
      <GridTexture />
      <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative">
        <SectionHeading
          kicker="Waarom TiviOne"
          title={
            <>
              Waarom kijkers kiezen voor{" "}
              <span className="text-transparent bg-clip-text bg-gradient-text">
                TiviOne
              </span>
            </>
          }
          subtitle="Eén premium abonnement in plaats van meerdere losse diensten en een dure kabelrekening."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {FEATURES.map((f, i) => (
            <Reveal
              key={f.title}
              delay={i * 70}
              className="group relative rounded-2xl bg-gradient-button p-[3px] shadow-md hover:shadow-glow-cyan-sm hover:-translate-y-1 transition-all duration-300 h-full"
            >
              <div className="rounded-[calc(1rem-3px)] bg-surface-card hover:bg-surface-card-hover p-6 sm:p-7 h-full transition-all duration-300">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-white/5 border border-line group-hover:bg-gradient-button group-hover:border-transparent flex items-center justify-center mb-4 sm:mb-5 transition-all duration-300">
                  <f.icon className="w-6 h-6 sm:w-7 sm:h-7 text-ink-secondary group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-2">{f.title}</h3>
                <p className="text-ink-secondary leading-relaxed text-sm sm:text-base">{f.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
